import React from 'react';
import { useNavigate } from 'react-router-dom';
import { CheckoutShell } from './CheckoutShell';

const NotFoundPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <CheckoutShell>
      <div className='flex-1 flex items-center justify-center p-6'>
        <div className='flex flex-col items-center gap-5 text-center max-w-sm'>
          <div
            className='text-6xl font-bold tabular-nums'
            style={{ color: 'var(--pp-text-subtle)', fontFamily: 'var(--pp-mono)' }}
          >
            404
          </div>
          <div>
            <h1
              className='text-lg font-semibold mb-1'
              style={{ color: 'var(--pp-text)' }}
            >
              Page not found
            </h1>
            <p className='text-sm' style={{ color: 'var(--pp-text-muted)' }}>
              This link is invalid or the page has been removed.
            </p>
          </div>
          <button
            onClick={() => navigate('/dashboard')}
            className='px-5 py-2.5 rounded text-sm font-semibold text-white'
            style={{ background: 'var(--pp-action)' }}
          >
            Go to dashboard
          </button>
        </div>
      </div>
    </CheckoutShell>
  );
};

export default NotFoundPage;
